import { normalizeTaskGridRows } from "../../../components/tasks/adapters/normalizeTaskGridRow";

const getTaskKey = (task) => {
  const taskId = task?.taskId ?? task?.id ?? task?.TaskId;
  return taskId == null ? null : String(taskId);
};

export const normalizeUniquePlanningTasks = (tasks) => {
  const normalizedTasks = normalizeTaskGridRows(tasks);
  const taskMap = new Map();

  normalizedTasks.forEach((task) => {
    const taskKey = getTaskKey(task);

    if (!taskKey) {
      taskMap.set(Symbol(), task);
      return;
    }

    const existingTask = taskMap.get(taskKey);
    taskMap.set(taskKey, {
      ...existingTask,
      ...task,
      estimateHours: task.estimateHours ?? existingTask?.estimateHours ?? 0,
      remainingHours: task.remainingHours ?? existingTask?.remainingHours ?? 0,
      remTime: task.remTime ?? existingTask?.remTime ?? task.remainingHours ?? existingTask?.remainingHours ?? 0,
    });
  });

  return Array.from(taskMap.values());
};

export default normalizeUniquePlanningTasks;
